export function generateUniqueId() {
  const now = new Date();

  const datePart =
    String(now.getFullYear()).slice(-2) +
    String(now.getMonth() + 1).padStart(2, "0") +
    String(now.getDate()).padStart(2, "0"); // "250422"

  const seconds = String(now.getSeconds()).padStart(2, "0"); // "00" to "59"
  const randomDigit = String(Math.floor(Math.random() * 10)); // 0-9

  // Create 8-digit ID
  return Number(datePart + seconds + randomDigit); // e.g., 250422315
}
